import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import moment from 'moment';
import { standardActions } from '../../Utils/GridFiltro/StandardActions';
import NavbarModulo from '../../components/NavbarModulo';

class NotaDebitoList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: true
    };
    
    componentDidMount = () => {
        const { listar, leerPeriodoD, getModulo } = this.props;
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5],periodo[4]);
        listar();
    }
    
    render(){
        const { data, loader, periodoD, modulo, eliminarND } = this.props;
        
        let ruta = window.location.href;
        let datos_emp = ruta.split('/');
        
        return(
            <React.Fragment>
                <NavbarModulo
                    periodoD = {periodoD}
                    modulo = {modulo}
                />
                <br />
                <h3 className="p-2 bg-secondary title">Notas de débito de planilla</h3>
                <br />
                <div className="d-flex flex-row justify-content-start mb-2">
                    <a
                        href={`/#/visitador_medico/${datos_emp[5]}/nota_debito_planilla/${datos_emp[7]}/crear`}
                        className='btn btn-primary'
                    >
                        Crear nota de débito
                    </a>
                
                </div>
                <div>
                    {data &&
                        <Grid 
                            hover 
                            striped 
                            data={data} 
                            loading={loader} 
                            headerStyle={ { background: 'black' } } 
                            //onPageChange={onPageChange}
                            //onSortChange={onSortChange} 
                        >
                            <TableHeaderColumn
                                isKey
                                dataField="fecha_registro"
                                dataSort
                                dataFormat={(cell, row)=>{
                                    return moment(cell).format("DD/MM/YYYY");
                                }}
                                thStyle={
                                    {color: 'white'}}
                                tdStyle={
                                    {color: 'white'}}
                            >
                                Fecha
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="numero"
                                dataSort
                                thStyle={
                                    {color: 'white'}}
                                tdStyle={
                                    {color: 'white'}}
                            >
                                Numero
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="400"
                                dataField="nombre_distribuidor"
                                dataSort
                                thStyle={
                                    {color: 'white'}}
                                tdStyle={
                                    {color: 'white'}}
                            >
                                Distribuidor
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                width="400"
                                dataField="pais"
                                dataSort
                                thStyle={
                                    {color: 'white'}}
                                tdStyle={
                                    {color: 'white'}}
                            >
                                Pais
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                headerAlign="center"
                                dataAlign='right'
                                dataField="monto"
                                dataFormat={(cell, row)=>{
                                    return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                                }}
                                dataSort
                                thStyle={
                                    {color: 'white'}}
                                tdStyle={
                                    {color: 'white'}}
                            >
                                Total
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                thStyle={
                                {color: 'white'}}
                                dataField="id"
                                dataAlign="center"
                                dataSort
                                dataFormat={standardActions({ 
                                    ver_a: "nota_debito_planilla",
                                    eliminarNDPlanilla: eliminarND,
                                    empresa: datos_emp[5],
                                    periodo: datos_emp[7],
                                    modulo: datos_emp[4],
                                })} 
                            >
                                Acciones
                            </TableHeaderColumn>
                        </Grid>
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default NotaDebitoList;
